import api from '../api';

export function useApi() {
    return api;
}
